"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCard = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var CardOrderStorage_1 = require("./CardOrderStorage");
var Card_1 = require("./card/Card");
var ActiveCardsSortingOrder_1 = require("../components/ActiveCardsSortingOrder");
var TranslateMixin_1 = require("./TranslateMixin");
var TerraformingRatingAccounting_1 = require("../turmoil/TerraformingRatingAccounting");
var constants_1 = require("../constants");
var CardType_1 = require("../cards/CardType");
exports.SelectCard = vue_1.default.component('select-card', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            cards: [],
            warning: undefined,
        };
    },
    components: {
        Card: Card_1.Card,
        Button: Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    watch: {
        cards: function () {
            this.$emit('cardschanged', this.getData());
        },
    },
    methods: {
        cardsSelected: function () {
            if (Array.isArray(this.cards)) {
                return this.cards.length;
            }
            else if (this.cards === false || this.cards === undefined) {
                return 0;
            }
            return 1;
        },
        getOrderedCards: function () {
            if (this.playerinput.cards === undefined) {
                return [];
            }
            if (this.playerinput.selectBlueCardAction) {
                return ActiveCardsSortingOrder_1.sortActiveCards(this.playerinput.cards);
            }
            else {
                return CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.player.id), this.playerinput.cards);
            }
        },
        hasCardWarning: function () {
            if (Array.isArray(this.cards)) {
                return false;
            }
            else if (typeof this.cards === 'object' && this.cards.warning !== undefined) {
                this.warning = this.cards.warning;
                return true;
            }
            return false;
        },
        hasRedsWarning: function () {
            if (this.playerinput.redsWarning !== true) {
                return false;
            }
            if (Array.isArray(this.cards)) {
                return false;
            }
            return (typeof this.cards === 'object') && (this.cards.cardType === CardType_1.CardType.STANDARD_PROJECT) && (TerraformingRatingAccounting_1.calculateTRGain(this.player, this.cards.name) > 0);
        },
        redsPenalty: function () {
            if (Array.isArray(this.cards)) {
                return 0;
            }
            if (typeof this.cards === 'object') {
                return TerraformingRatingAccounting_1.calculateTRGain(this.player, this.cards.name) * constants_1.REDS_RULING_POLICY_COST;
            }
            else {
                return 0;
            }
        },
        isSelectionOptional: function () {
            return this.playerinput.minCardsToSelect === 0;
        },
        getData: function () {
            return Array.isArray(this.$data.cards) ? this.$data.cards.map(function (card) { return card.name; }) : [this.$data.cards.name];
        },
        saveData: function () {
            this.onsave([this.getData()]);
        },
        getCardBoxClass: function (card) {
            if (this.playerinput.showOwner && this.getOwner(card) !== undefined) {
                return 'cardbox cardbox-with-owner-label';
            }
            return 'cardbox';
        },
        getOwner: function (card) {
            for (var _i = 0, _a = this.player.players; _i < _a.length; _i++) {
                var player = _a[_i];
                if (player.playedCards.find(function (c) { return c.name === card.name; })) {
                    return { name: player.name, color: player.color };
                }
            }
            return undefined;
        },
        isSelectOnlyOneCard: function () {
            return this.playerinput.maxCardsToSelect === 1 && this.playerinput.minCardsToSelect === 1;
        },
        buttonLabel: function () {
            return this.isSelectOnlyOneCard() ? this.playerinput.buttonLabel : this.playerinput.buttonLabel + ' ' + this.cardsSelected();
        },
    },
    template: "<div class=\"wf-component wf-component--select-card\">\n        <div v-if=\"showtitle === true\" class=\"nofloat wf-component-title\">{{ $t(playerinput.title) }}</div>\n        <label v-for=\"card in getOrderedCards()\" :key=\"card.name\" :class=\"getCardBoxClass(card)\">\n            <template v-if=\"!card.isDisabled\">\n              <input v-if=\"isSelectOnlyOneCard()\" type=\"radio\" v-model=\"cards\" :value=\"card\" />\n              <input v-else type=\"checkbox\" v-model=\"cards\" :value=\"card\" :disabled=\"playerinput.maxCardsToSelect !== undefined && Array.isArray(cards) && cards.length >= playerinput.maxCardsToSelect && cards.includes(card) === false\" />\n            </template>\n            <Card v-if=\"playerinput.showOwner && getOwner(card) !== undefined\" :card=\"card\" :owner=\"getOwner(card)\" />\n            <Card v-else :card=\"card\"  />\n        </label>\n        <div v-if=\"hasCardWarning()\" class=\"card-warning\">{{ $t(warning) }}</div>\n        <div v-if=\"hasRedsWarning()\" class=\"card-warning\">\n          <div>Reds party is currently ruling.</div>\n          <div>You will lose {{ redsPenalty() }} mc if you play this card.</div>\n        </div>\n        <div v-if=\"showsave === true\" class=\"nofloat\">\n            <Button :disabled=\"isSelectionOptional() && cardsSelected() === 0\" type=\"submit\" :onClick=\"saveData\" :danger=\"playerinput.buttonDanger\" :title=\"buttonLabel()\" />\n            <Button :disabled=\"isSelectionOptional() && cardsSelected() > 0\" v-if=\"isSelectionOptional()\" :onClick=\"saveData\" type=\"submit\" :danger=\"true\" :title=\"$t('Skip this action')\" />\n        </div>\n    </div>",
});
//# sourceMappingURL=SelectCard.js.map